import { cn } from "@/lib/utils";

export function GlassCard({ as: Tag = "div", className, children, testId, ...rest }) {
  return (
    <Tag
      data-testid={testId}
      className={cn("nn-glass p-5", className)}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export function GlassCardHeader({ title, hint, action, className }) {
  return (
    <div className={cn("mb-4 flex items-start justify-between gap-4", className)}>
      <div className="min-w-0">
        <h3 className="text-[13px] font-semibold tracking-tight text-[hsl(var(--nn-ink))]">
          {title}
        </h3>
        {hint && (
          <p className="mt-0.5 text-[11px] font-normal text-[hsl(var(--nn-ink-muted))]">
            {hint}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}

export default GlassCard;
